import { ReactElement, useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PaywallModal from '../components/PaywallModal'
import { RootState } from '../app/store'
import { useAppSelector } from '../app/typedReduxHooks'
import { routes } from '../pages/routes'

export interface UsePaywallResult {
  isOpen: boolean
  open: () => void
  close: () => void
  hasSubscriptionError: boolean
  paywallModal: ReactElement
}

export const usePaywall = (): UsePaywallResult => {
  const navigate = useNavigate()
  const { error: subscriptionError } = useAppSelector(
    (state: RootState) => state.billing?.subscription
  )
  const planCode = useAppSelector(
    (state: RootState) => state.organization.entitlements?.planCode ?? null
  )

  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])

  const handleUpgrade = useCallback(() => {
    setIsOpen(false)
    navigate(routes.pricePlan.path)
  }, [navigate])

  const paywallModal = (
    <PaywallModal isOpen={isOpen} onClose={close} onUpgrade={handleUpgrade} planCode={planCode} />
  )

  return {
    isOpen,
    open,
    close,
    hasSubscriptionError: !!subscriptionError,
    paywallModal,
  }
}
